import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { AuthProvider } from "./features/auth/AuthProvider";
import "./styles/global.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      /* Entitlements change without the client acting — a Stripe webhook can flip
         a subscription while the user sits on another tab. Refetching on focus is
         what keeps the snapshot from going stale after a purchase or a cancel. */
      refetchOnWindowFocus: true,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

async function boot() {
  if (import.meta.env.VITE_MOCKS === "on") {
    const { startMocks } = await import("./mocks/browser");
    await startMocks();
  }

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void boot();
